"use client";

import {
  Text,
  Field,
  withDatasourceCheck,
  useSitecoreContext,
} from "@sitecore-jss/sitecore-jss-nextjs";
import clsx from "clsx";
import { ComponentProps } from "@repo/sitecore-lib/component-props";
import * as Flex from "@repo/ui/flex";
import { TYPOGRAPHY_HEADING4 } from "@/theme/topshop-2/typography/typography-constants";
import Placeholder from "../../../placeholder-component/placeholder";
import { isMobile } from "../../../utils";
import styles from "./links-images.module.css";

export type ImageListProps = ComponentProps & {
  fields: {
    title: Field<string>;
  };
};

const ImageList = (props: ImageListProps): JSX.Element | null => {
  const { sitecoreContext } = useSitecoreContext();
  const isEditing = sitecoreContext?.pageEditing;
  const placeholders = props.rendering.placeholders;
  const mobileView = isMobile();

  return (
    <Flex.Container
      className={clsx(
        styles.linkImageContainer,
        isEditing && styles.editingImageContainer,
      )}
      column
      gap="lg"
    >
      <Text
        tag="p"
        className={clsx(
          isEditing && styles.editingSpacing,
          styles.linkImageTitle,
          TYPOGRAPHY_HEADING4,
        )}
        field={props.fields.title}
      />
      <Flex.Container
        gap="lg"
        justify={mobileView ? "center" : "start"}
        className={clsx(styles.linkImageList)}
        wrap
      >
        <Placeholder
          name="faq-image-links-{*}"
          rendering={props.rendering}
          classname="cc-imageLink"
          key={
            isEditing && placeholders
              ? JSON.stringify(placeholders["faq-image-links-{*}"]?.length)
              : undefined
          }
        />
      </Flex.Container>
    </Flex.Container>
  );
};

export default withDatasourceCheck()<ImageListProps>(ImageList);
